<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="10">
                <div class="spreadsheet-header-title">
                    {{ title }}
                </div>
            </el-col>
        </el-row>
        <el-row align="top" class="spreadsheet-table" v-loading="loading">
            <el-row align="top" class="spreadsheet-table-filter-info">
                <el-col :span="1" class="text-center bold">
                    Дата:
                </el-col>
                <el-col :span="5">
                    <el-date-picker
                        v-model="daysRange"
                        type="daterange"
                        range-separator="по"
                        start-placeholder="дата"
                        end-placeholder="дата"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                        @change="getDataFromServer"
                    />
                </el-col>
                <el-col :span="1" class="text-center bold">
                    Офис:
                </el-col>
                <el-col :span="3">
                    <el-select
                        v-model="officeId"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        placeholder=""
                        size="mini"
                        clearable
                        @change="changeOfficeId"
                    >
                        <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>
                <el-col :span="2" class="text-center bold">
                    Сотрудник:
                </el-col>
                <el-col :span="4">
                    <el-select
                        v-model="employerId"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        placeholder=""
                        size="mini"
                        clearable
                        filterable
                        autocomplete
                        @change="changeEmployerId"
                    >
                        <el-option v-for="item in employersList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>
            </el-row>
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="10">
                <div class="spreadsheet-header-title">
                    Итого: расходов на {{ pagesInfo.totalAmount }} р.
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Всего строк: {{ pagesInfo.total }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import capitalize from 'lodash/capitalize';
import { formatFinance } from '@/common/utilities';
import moment from 'moment';
import '@/assets/styles/list.scss';

library.add(faEye);

export default {
    name: 'RegistryEmployersGrid',
    data() {
        return {
            title: 'Реестр расходов по сотрудникам',
            officeId: null,
            employerId: null,
            daysRange: [
                moment().startOf('month').format('DD.MM.YYYY'),
                moment().endOf('month').format('DD.MM.YYYY')
            ],
            isFilterFormVisible: false,
            filterModel: {
                source_id: null,
                recipient_id: null,
                pay_type: null,
                date: null,
                amount: null
            },
            fieldsNames: {
                source_id: 'Офис',
                recipient_id: 'Сотрудник',
                pay_type: 'Вид платежа (@/ р/с / карта)',
                date: 'Дата',
                amount: 'Сумма'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            pickerOptions,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: []
        };
    },
    components: {
        'ag-grid-vue': AgGridVue
    },
    computed: {
        registryEmployers() {
            return this.$store.state.registryEmployers.registryEmployers;
        },
        officeList() {
            return this.$store.state.references.offices;
        },
        employersList() {
            return this.$store.state.references.employers;
        },
        pagesInfo() {
            return this.$store.state.registryEmployers.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        startDay() {
            return this.daysRange[0];
        },
        endDay() {
            return this.daysRange[1];
        }
    },
    created() {
        this.columnDefs = [
            {
                headerName: this.fieldsNames.source_id,
                field: 'source_id',
                cellRenderer: ({ data }) => data.source ? data.source.office.name : '',
                width: 300
            },
            {
                headerName: this.fieldsNames.recipient_id,
                field: 'recipient_id',
                cellRenderer: ({ data }) => data.recipient.name,
                width: 300
            },
            {
                headerName: this.fieldsNames.pay_type,
                field: 'pay_type',
                cellRenderer: ({ data }) => data.pay_type.name,
                width: 300
            },
            {
                headerName: this.fieldsNames.date,
                field: 'date',
                width: 300
            },
            {
                headerName: this.fieldsNames.amount,
                field: 'amount',
                cellRenderer: ({ data }) => formatFinance(data.amount),
                cellClass: 'text-right'
            }
        ];
    },
    mounted() {
        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(() => {
            this.getDataFromServer();
        });
    },
    methods: {
        changeOfficeId() {
            this.employerId = null;
            this.getDataFromServer();
        },
        changeEmployerId() {
            this.officeId = null;
            this.getDataFromServer();
        },
        setSettings() {
            if (this.setting.registryEmployers) {
                this.gridOptions.columnApi.setColumnState(this.setting.registryEmployers.table);
                this.gridOptions.api.setSortModel(this.setting.registryEmployers.sort);
                this.filterModel = JSON.parse(JSON.stringify(this.setting.registryEmployers.filter));
                this.pageModel = JSON.parse(JSON.stringify(this.setting.registryEmployers.page));
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
                element.innerText = name;
            }
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel,
                tableFilter: {
                    office_id: this.officeId,
                    employer_id: this.employerId,
                    startDay: this.startDay,
                    endDay: this.endDay
                }
            };
            this.loading = true;
            this.$store.dispatch('registryEmployers/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.registryEmployers);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                    this.loading = false;
                }).catch(
                error => {
                    if (error.response) {
                        this.loading = false;
                    }
                }).finally(() => {
            });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {
                'registryEmployers': {
                    'table': this.gridOptions.columnApi.getColumnState(),
                    'sort': this.gridOptions.api.getSortModel(),
                    'filter': this.filterModel,
                    'page': this.pageModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize: capitalize
    }
};
</script>
